import { render, staticRenderFns } from "./ResourceAdd.vue?vue&type=template&id=5c5b58dd"
import script from "./ResourceAdd.vue?vue&type=script&lang=js"
export * from "./ResourceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports